import React from 'react'
import classNames from 'classnames'

function Table({ children, headers = [], modifierClasses = [] }) {
  const classes = classNames(
    'table',
    'table--search',
    `table--${headers.length}-col`,
    modifierClasses,
  )

  return (
    <div className={classes}>
      <div className="table__inner">
        <table className="RS_CONTENT"> {/* NOTE: ReadySpeaker class */}
          <thead>
            <tr>
              { headers.map(name => (
                <th><span className='label u-text-uppercase u-inline-block'>{name}</span></th>
              ))}
            </tr>
          </thead>
          <tbody>
          { children }
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default Table
